import React from "react";
import "../index.css";
import TableHeader from "../../../../../components/TableHeader/index";
import Pagination from "../../../../../components/Pagination";
import CustomerCareController from "../../../../../services/qlts/customer-care-controller/customer-care-controller";
import {toast} from "react-toastify";
import DatePicker, {registerLocale} from "react-datepicker";
import moment from "moment/moment";
import vi from "date-fns/locale/vi";
import {CustomerSourceType} from "../enums/customerSourceType";
import {CustomerCareActivity} from "../enums/customerCareActivity";
import {CustomerCareStyle} from "../enums/customerCareStyle";
registerLocale("vi", vi);
class HistorySupport extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            style : "NOTE",
            activity : "NEW",
            customerId : props.customerId,
            appointmentDate : new Date(),

            listData: [],
            pageNumber: 0,
            pageSize: 10,

            sort: 'ASC',
            descending: 'DESC',
            totalItem: 0,
            contentChat: "",
            header: [
                {
                    id: "123",
                    name: "STT",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "child",
                    name: "Người phụ trách",
                    style: {textAlign: "left"},
                    sort: false
                },
                {
                    id: "name",
                    name: "Mô tả",
                    style: {textAlign: "left"},
                    sort: false
                },
                {
                    id: "activity",
                    name: "Hành động",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "state",
                    name: "Trạng thái",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "support",
                    name: "Ngày",
                    style: {textAlign: "center"},
                    sort: false
                }
            ]
        };
    }
    UNSAFE_componentWillReceiveProps(nextProps, nextContext){
        this.setState({
            showLoading: true,
            customerId:  nextProps.customerId,
            appointmentDate:  new Date(),
        }, () =>{
            this.getListCustomerCare()
        })
    }
    getListCustomerCare() {
        let payload = {
            pageNumber: this.state.pageNumber,
            pageSize: this.state.pageSize,
            customerId: this.state.customerId,
            sort: "created_at desc"
        };
        CustomerCareController.getListCustomerCare(payload, res => {
            if (res.success) {
                let data = res.data;
                this.setState(
                    {
                        listData: data.content,
                        totalItem: data.totalElements,
                        totalPage: Math.round(data.totalElements / this.state.pageSize),
                        showLoading: false
                    }
                );
            } else {
                this.setState(
                    {
                        showLoading: false
                    }
                );
            }
        });
    }
    renderCustomerCareActivity(){
        return CustomerCareActivity.map((item, index) => <option value={item.id}>{item.name}</option>)
    }
    renderActivity(activity){
        for (let pos in CustomerCareActivity){
            if (activity === CustomerCareActivity[pos].id)
                return CustomerCareActivity[pos].name
        }
        return ""
    }
    renderState(state){
        for (let pos in CustomerCareStyle){
            if (state === CustomerCareStyle[pos].id)
                return CustomerCareStyle[pos].name
        }
        return ""
    }
    createAppointment() {
        this.props.onUpdateAppointment(this.state.appointmentDate)
        this.createCustomerCare("SCHEDULE")
    }
    createChat() {
        this.createCustomerCare("NOTE")
    }
    createCustomerCare(state) {
        let payload = {
            content: this.state.contentChat,
            customerId: this.state.customerId,
            activity: this.state.activity,
            state: state,
            scheduleDate: this.state.appointmentDate,
        };
        CustomerCareController.createCustomerCare(payload, res => {
            if (res.success) {
                toast.success("Thêm thành công!")
                this.getListCustomerCare()
            }else {
                toast.error(res.message[0])
            }
        });
    }
    handleChangePage = page => {
        this.setState(
            {
                pageNumber: page
            },
            () => {
                this.getListCustomerCare();
            }
        );
    };

    // ------------------------------------------------------------------------------------------------------

    render() {
        let {listData, pageNumber, header} = this.state;
        return (
            <div className="row">
                <div className="col-12 p-2 mb-2 bg-info bg-gradient text-white">Lịch chăm sóc</div>
                <div className="col-md-6 col-xs-12">
                    <div className="col-md-12 col-xs-12 d-flex mb-2">
                        <label className="col-md-12 col-xs-12 label-item pl-0">Nội dung</label>
                    </div>
                    <div className="col-md-12 col-xs-12 d-flex mb-2 mt-2">
                        <textarea
                            rows={6}
                            placeholder="Nhập nội dung"
                            className="form-control shadow-none"
                            name="contentChat"
                            onChange={(e) => {
                                this.setState({
                                    contentChat: e.target.value
                                })
                            }}
                            value={this.state.contentChat}/>
                    </div>
                </div>
                <div className="col-md-6 col-xs-12">
                    <div className="col-md-12 col-12 d-flex mb-2 mt-2">
                    </div>
                    <div className="col-md-12 col-12 d-flex mb-2 mt-2">
                        <label className="col-md-4 col-xs-12 label-item pl-0">Ngày hẹn</label>
                        <DatePicker
                            locale="vi"
                            className="w-auto  form-control kt-input pd-4-input hei-input"
                            selected={this.state.appointmentDate === '' ? null : new Date(this.state.appointmentDate)}
                            minDate={new Date()}
                            placeholderText="Ngày-Tháng-Năm"
                            dateFormat="dd-MM-yyyy"
                            showMonthDropdown
                            showYearDropdown
                            onChange={
                                (date) => {
                                    let value = moment(date).format("YYYY-MM-DD").toString();
                                    try {
                                        this.setState({
                                            appointmentDate: value == "Invalid date" ? null : moment(value).format("YYYY-MM-DD"),
                                            inEditing: true
                                        })

                                    }catch (e) {

                                    }
                                }
                            }
                        />
                    </div>
                    <div className="col-md-12 col-12 d-flex mb-2 mt-2">
                        <label className="col-md-4 col-xs-12 label-item pl-0">Hành động</label>
                        <select
                            className="form-control kt-input pd-4-input hei-input"
                            value={this.state.activity}
                            onChange={(e) => {
                                this.state.activity = e.target.value;
                                this.setState({
                                    activity: e.target.value
                                })
                            }}
                        >
                            {this.renderCustomerCareActivity()}
                        </select>
                    </div>
                </div>
                <div className="d-flex align-right col-md-12 col-xs-12 row">
                    <div className="d-flex justify-content-center align-center mt-3 mb-2 col-md-12 col-xs-12">
                        <button
                            style={{minWidth: "fit-content"}}
                            type="button"
                            className="col-md-2 col-xs-2 border-1-s w-50 type-button-fix btn btn-info mr-2"
                            onClick={() => this.createChat()}
                        >
                                        <span className=''>
                                            Thêm chú thích
                                        </span>
                        </button>
                        <button
                            style={{minWidth: "fit-content", marginRight: "10px"}}
                            type="button"
                            className="col-md-2 col-xs-2 border-1-s background-btn w-50 type-button-fix btn btn-primary"
                            onClick={() => this.createAppointment()}
                        >
                                        <span className='justify-content-center'>
                                            Đặt lịch
                                        </span>
                        </button>

                    </div>
                </div>
                <div className="d-flex align-left col-md-12 col-xs-12 row">
                    <label className="label-item pl-0">Lưu ý: Hệ thống chỉ lưu thời gian hẹn lịch cuối cùng vào chức năng "Lịch hẹn hôm nay"</label>
                </div>
                <div className="col-12 p-2 mb-2">
                    <div className="p-0 mb-3">
                        <div className="table-wrapper">
                            <table
                                className="table table-striped table-data table-responsive table-bordered">
                                <table className="table">
                                    <thead>
                                    <TableHeader
                                        header={header}
                                        clickSort={data => {
                                            let a = "";
                                            let descend = "";
                                            if (data.sortAsc == null) {
                                                // a = "id=asc";
                                                a = "id";
                                                descend = 'DESC'
                                            } else {
                                                a = data.sortId;
                                                descend = data.sortAsc ? 'ASC' : 'DESC'
                                            }
                                            this.setState(
                                                {
                                                    sort: a,
                                                    descending: descend
                                                },
                                                () => this.getListCustomerCare()
                                            );
                                        }}
                                    />
                                    </thead>
                                    {!this.state.listData ||
                                    this.state.listData.length == 0 ? (
                                        <tbody>
                                        <tr>
                                            <td colSpan={12}>
                                                <div className="text-center">
                                                    Không có dữ liệu
                                                </div>
                                            </td>
                                        </tr>
                                        </tbody>
                                    ) : (
                                        <tbody>
                                        {listData &&
                                            listData.length > 0 &&
                                            listData?.map((row, index) => (
                                                <tr style={{height: 50}}>
                                                    <td style={{textAlign: "center"}} scope="row">
                                                        {" "}
                                                        {this.state.pageNumber * this.state.pageSize +
                                                            index +
                                                            1}
                                                    </td>
                                                    <td style={{textAlign: "left"}} scope="row">
                                                        {row.userRes.username}
                                                    </td>
                                                    <td style={{textAlign: "left"}} scope="row">
                                                        {row.content}
                                                    </td>
                                                    <td style={{textAlign: "center"}} scope="row">
                                                        {this.renderActivity(row.activity)}
                                                    </td>
                                                    <td style={{textAlign: "center"}} scope="row">
                                                        {row.state=="NOTE" ? <span className="badge badge-success" style={{color: "white"}}>Chú thích</span> : <span className="badge badge-danger" style={{color: "white"}}>Hẹn lịch</span>}
                                                    </td>
                                                    <td style={{textAlign: "center"}} scope="row">
                                                        {row.state=="NOTE"? moment(row.createdAt).format("DD-MM-YYYY").toString():moment(row.scheduleDate).format("DD-MM-YYYY").toString()}
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    )}
                                </table>
                            </table>
                        </div>
                        <div className="pagination-right">
                            <Pagination
                                activePage={this.state.pageNumber}
                                itemsCountPerPage={this.state.pageSize}
                                totalItemsCount={this.state.totalItem}
                                changeHandler={page => this.handleChangePage(page)}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
export default HistorySupport;
